var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tip-root ant-tooltip yxt-tooltip__popper is-dark",
      style: { display: _vm.display, left: _vm.left, top: _vm.top },
      attrs: { "data-placement": _vm.placement },
    },
    [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.msg) } }),
      _c("div", { staticClass: "arrow" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }